<!-- MAIN CONTAINER -->
<div class="d-flex flex-column vh-100">

    <!-- FIXED SPACE FOR MAIN NAV BAR-->
    <div class="container">
        <div class="row my-3 py-3">
        </div>
    </div>


    <!-- FORM HEADER -->
    <div class="container">
        <div class="card card-body INN-form justify-content-center mt-4">
            <div class="row">

                <!-- FORM TITLE -->
                <div class="col-6">
                    <h4 class="card-title lg-3 mb-lg-1 text-body-secondary">
                        <i class="bi bi-folder-check me-2 fs-1 text-primary"></i>Registrar refacturación
                    </h4>
                </div>

                <div class="col-6 align-items-lg-end">
                    <div class="row">
                        <!-- FUNCTIONS BUTTONS -->
                        
                        <div class="col ms-2 m-lg-0 d-lg-flex justify-content-lg-end align-items-lg-end">
                            
                            <div *ngIf="opE === '1' && mostrarBtnReFactura === false" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                                <button (click)="editar()" class="INN-function-button link-opacity-50-hover text-decoration-none link-secondary fs-6">
                                    <i class="bi-pencil-square me-2"></i>Editar
                                </button>
                            </div>

                            <div *ngIf="opE === '1' " class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                                <button class="INN-function-button link-opacity-50-hover text-decoration-none link-secondary f-6" data-bs-toggle="collapse" href="#multiCollapseExample1" role="button" aria-expanded="false" aria-controls="multiCollapseExample1">
                                    <i class="bi bi-chat-left-text me-2"></i>Comentario
                                </button>
                            </div>

                            <div *ngIf="opE === '1' && mostrarBtnVoBo === false && this.FacPro_VoBo !== 'VoBo' " class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                                <button (click)="cambioEstatus()" class="INN-function-button link-opacity-50-hover text-decoration-none link-success fs-6">
                                    <i class="bi bi-person-check-fill me-2 "></i>VoBo
                                </button>
                            </div>

                            <div *ngIf="opE === '1' && mostrarBtnReFactura === false" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                                <button (click)="eliminar()" class="INN-function-button link-opacity-50-hover text-decoration-none link-danger fs-6">
                                    <i class="bi-trash3 me-2"></i>Eliminar
                                </button>
                            </div>

                            <div *ngIf="opE === '2' " class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                                <button (click)="guardar()" class="INN-function-button link-opacity-50-hover text-decoration-none link-secondary fs-6">
                                    <i class="bi-save me-2"></i>Guardar
                                </button>
                            </div>

                            <div class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                                <button (click)="cancelar()" class="INN-function-button link-opacity-50-hover text-decoration-none link-secondary fs-6">
                                    <i [ngClass]="[iconoMostrar, 'me-2']"></i> {{nameBoton}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- FORM CONTENT -->
    <div class="container pe-6">
        <div class="card card-body INN-form justify-content-center mt-2">
            <form class="needs-validation" novalidate>
                <div class="row g-3">
                    <p class="small text-primary" *ngIf="validacionRol !== 'Otro rol' && opE === '1' ">
                        <i class="bi bi-person-circle me-2"> </i> {{validacionRol}} 
                    </p>
                    <!-- FORM TITLE -->
                    <div class="col-12 col-lg-5">
                        <h4 class="card-title lg-3 mb-lg-1 text-body-secondary">
                            Factura a remplazar
                        </h4>
                    </div>

                    <div class="collapse multi-collapse" id="multiCollapseExample1">
                        <!-- TEXT AREA -->
                        <div class="col-md-12">
                            <label for="formControlTextarea1" class="form-label">Comentarios</label>
                            <textarea class="form-control" name="refactura.FacPro_Observaciones" id="refactura.FacPro_Observaciones" [(ngModel)]="refactura.FacPro_Observaciones" rows="2" [disabled]="esAdministrador()"></textarea>
                        </div>
                        <br>
                        <button *ngIf="rol === 'Administrador' && FacPro_VoBo !== 'Aclaracion'" (click)="comentarios()" type="button" class="col-3 btn btn-outline-secondary INN-color-white-hover">
                             <i class="bi bi-chat-left-text me-2"></i>Enviar comentarios
                        </button>
                    </div>

                    <!-- Datos datos de facturación  -->
                    <!-- FIELD BUTTON -->
                    <div class="col-md-12">
                        <label for="Field" class="form-label">No. Factura</label>
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" name="FacPro_NoFactura" id="FacPro_NoFactura" [(ngModel)]="FacPro_NoFactura" [disabled]="validacionCampos === false || opE != '2'">
                            <button *ngIf="opE === '2'" (click)="Buscar()" class="btn btn-outline-secondary" type="button">Buscar</button>
                        </div>
                        <p *ngIf="showErrorMessageBuscar === true" class="mensaje-error">
                            {{mensajeValidacionBuscar}}
                        </p>
                    </div>

                    <!-- MENU FIELD -->
                    <div class="col-md-8">
                        <label for="menuField" class="form-label">Proyecto</label>
                        <input type="text" class="form-control" name="FacPro_NomProyecto" id="FacPro_NomProyecto" [(ngModel)]="FacPro_NomProyecto" disabled>
                    </div>

                    <!-- FIELD SYMBOL LEFT-->
                    <div class="col-md-4">
                        <label for="Field" class="form-label">Importe sin IVA</label>
                        <div class="input-group">
                            <span class="input-group-text">$</span>
                            <input type="text" class="form-control" name="FacPro_Importe" id="FacPro_Importe" [value]="FacPro_Importe | number:'1.0-0'" disabled>
                        </div>
                    </div>

                    <!-- SPACER -->
                    <div class="col-md-9 m-0 p-0">
                    </div>

                    <!-- DATE PICKER-->
                    <div class="col-md-4">
                        <label for="date" class="form-label">Fecha de facturación</label>
                        <input type="text" class="form-control" name="FacPro_FechaIngreso" id="FacPro_FechaIngreso" [(ngModel)]="FacPro_FechaIngreso" disabled>
                    </div>

                    <!-- MENU FIELD -->
                    <div class="col-md-4">
                        <label for="menuField" class="form-label">Mes de servicio</label>
                        <input type="text" class="form-control" name="FacPro_MesServicio" id="FacPro_MesServicio" [(ngModel)]="FacPro_MesServicio" disabled>
                    </div>

                    <div class="col-md-4">
                        <label for="Field" class="form-label">Año de servicio</label>
                        <div class="input-group">                            

                            <select class="form-select" name="FacPro_AnoServicio" [(ngModel)]="FacPro_AnoServicio" [disabled]="true">
                                <option *ngFor="let anioItem of anios" [ngValue]="anioItem">
                                    {{ anioItem }}
                                </option>
                            </select>                                           
                            
                        </div>
                    </div>

                    <div class="col-12" *ngIf="pastAttachments.length > 0">
                        <h4 class="card-title">
                            Documentos de factura original 
                        </h4>

                        <div class="row g-3">

                            <div class="col-sm-12 col-md-6 col-lg-3" *ngFor="let document of pastAttachments; let i=index">
                                <div class="input-group mb-3">
                                    <div title="Ver">
                                        <button type="button" class="btn btn-outline-danger INN-color-white-hover btn-pdf" (click)="openModal(document, 'facturas')">
                                            <i class="bi bi-file-earmark-pdf-fill"></i>
                                        </button>
                                    </div>
                                    <input type="text" class="form-control" placeholder="{{document.FacDoc_Nombre}}" disabled aria-label="Username" aria-describedby="basic-addon1">

                                    <div title="Descargar">
                                        <button class="btn btn-outline-primary INN-color-white-hover rounded-0" type="button" id="basic-addon1" (click)="downloadDocument(document, 'facturas')">
                                            <i class="bi bi-download  px-1"></i>
                                        </button>
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>

                    <!-- BAR -->
                    <hr class="mt-4 mb-0">

                    <!-- FORM TITLE -->
                    <div class="col-12 col-lg-5">
                        <h4 class="card-title lg-3 mb-lg-1 text-body-secondary">
                            Nueva factura
                        </h4>
                    </div>

                    <!-- Nuevos datos de re-facturación  -->
                    <!-- FIELD -->
                    <div class="col-md-12">
                        <label for="Field" class="form-label">No. Factura</label>
                        <input type="text" class="form-control" name="ReFacPro_NoFactura" id="ReFacPro_NoFactura" [(ngModel)]="ReFacPro_NoFactura" #fact="ngModel" [ngClass]="{'is-invalid': fact.invalid && (fact.dirty || fact.touched)}" (ngModelChange)="mostrarMensaje(fact, 'factura')"
                            (blur)="mostrarMensaje(fact, 'factura')" required [disabled]="validacionCampos === false ">
                        <p *ngIf="showErrorMessageFac === true" class="invalid-feedback">
                            {{mensajeValidacionFac}}
                        </p>
                    </div>


                    <!-- MENU FIELD -->
                    <div class="col-md-8">
                        <label for="menuField" class="form-label">Proyecto</label>
                        <input type="text" class="form-control" name="FacPro_NomProyecto" id="FacPro_NomProyecto" [(ngModel)]="FacPro_NomProyecto" disabled>
                    </div>

                    <!-- FIELD SYMBOL LEFT-->
                    <div class="col-md-4">
                        <label for="Field" class="form-label">Importe sin IVA</label>
                        <div class="input-group">
                            <span class="input-group-text">$</span>
                            <input type="text" class="form-control" name="ReFacPro_Importe" min="0" [(ngModel)]="ReFacPro_Importe" #imp="ngModel" [ngClass]="{'is-invalid': imp.invalid && (imp.dirty || imp.touched)}" (ngModelChange)="mostrarMensaje(imp, 'importe')" (blur)="mostrarMensaje(imp, 'importe')"
                                (input)="filterInput($event)" required [disabled]="validacionCampos === false ">
                            <p *ngIf="showErrorMessageImp === true" class="mensaje-error">
                                {{mensajeValidacionImp}}
                            </p>
                        </div>
                    </div>

                    <!-- SPACER -->
                    <div class="col-md-9 m-0 p-0"></div>

                    <!-- DATE PICKER-->
                    <div class="col-md-4">
                        <label for="Field" class="form-label">Fecha de ingreso de facturación</label>
                        <div class="input-group">
                            <input class="form-control" type="date" name="ReFacPro_FechaIngreso" [(ngModel)]="ReFacPro_FechaIngreso" #ingreso="ngModel" [ngClass]="{'is-invalid': ingreso.invalid && (ingreso.dirty || ingreso.touched)}" (ngModelChange)="mostrarMensaje(ingreso, 'ingreso')"
                                (blur)="mostrarMensaje(ingreso, 'ingreso')" [max]="maxFechaHoy" required [disabled]="validacionCampos === false ">
                            <p *ngIf="showErrorMessageIng === true" class="mensaje-error">
                                {{mensajeValidacionIng}}
                            </p>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <label for="menuField" class="form-label">Mes de servicio</label>
                        <select class="form-select" name="ReFacPro_MesServicio" [(ngModel)]="ReFacPro_MesServicio" #mes="ngModel" [ngClass]="{'is-invalid': mes.invalid && (mes.dirty || mes.touched)}" (ngModelChange)="mostrarMensaje(mes, 'mes')"
                        (blur)="mostrarMensaje(mes, 'mes')" required [disabled]="validacionCampos === false">
                            <option [ngValue]="''">Seleccione mes de servicio...</option>
                            <option *ngFor="let mes of meses" [value]="mes">{{ mes }}</option>
                        </select>
                        <p *ngIf="showErrorMessageMes === true" class="mensaje-error">
                            {{mensajeValidacionMes}}
                        </p>
                    </div>

                    <div class="col-md-4">
                        <label for="Field" class="form-label">Año de servicio</label>
                        <div class="input-group">                            
                            <select class="form-select" name="ReFacPro_AnoServicio" [(ngModel)]="ReFacPro_AnoServicio" #anio="ngModel" [ngClass]="{'is-invalid': anio.invalid && (anio.dirty || anio.touched)}" (ngModelChange)="mostrarMensaje(anio, 'anio')"
                            (blur)="mostrarMensaje(anio, 'anio')" required [disabled]="validacionCampos === false">
                                <option [ngValue]="''">Seleccione un año de servicio...</option>
                                <option *ngFor="let anioItem of anios" [ngValue]="anioItem">
                                    {{ anioItem }}
                                </option>
                            </select>
                            <p *ngIf="showErrorMessageAnio === true" class="mensaje-error">
                                {{mensajeValidacionAnio}}
                            </p>       
                        </div>
                    </div>

                    <!-- Este boton nos sirve para agregar las facturas originales
                    
                    <div class="col-12" *ngIf="ReFacPro_NoFactura !== '' && attachments.length === 0 && newdocuments.length === 0">
                        <button type="button" class="btn btn-secondary btn-sm text-light" (click)="emparejarDocumentos()">
                            Agregar los documentos de la facturas: {{FacPro_NoFactura}}
                        </button>
                    </div> -->

                    <!-- COMPONENT PREVIEW PDF -->
                    <app-viewpdf [pdfUrl]="pdfUrl" [modalVisible]="modalVisible" [namepdf]="namepdf" (modalClosed)="onModalClosed()" *ngIf="modalVisible"></app-viewpdf>

                    <!-- ATTACH FILE ARRANGE WITHOUT BUTTON -->
                    <app-loading [loading]="loading" [message]="message" [loadingDocuments]="loadingDocuments" [progressPercentage]="progressPercentage"></app-loading>
                    <div class="container mt-4">
                        <div class="card">
                            <div class="card-body">
                                <!-- Tabla de Documentos Almacernados en S3 -->
                                <div class="row g-3">
                                    <h5 class="card-title" *ngIf="attachments.length > 1">Documentos Adjuntos</h5>

                                    <div class="col-sm-12 col-md-6 col-lg-3" *ngFor="let document of attachments; let i=index">
                                        <div class="input-group mb-3">
                                            <div title="Ver">
                                                <button type="button" class="btn btn-outline-danger INN-color-white-hover btn-pdf" (click)="openModal(document, 'refacturas')">
                                                    <i class="bi bi-file-earmark-pdf-fill"></i>
                                                </button>
                                            </div>
                                            <input type="text" class="form-control" placeholder="{{document.FacDoc_Nombre}}" disabled aria-label="Username" aria-describedby="basic-addon1">

                                            <div title="Descargar">
                                                <button class="btn btn-outline-primary INN-color-white-hover rounded-0" type="button" id="basic-addon1" (click)="downloadDocument(document, 'refacturas')">
                                                    <i class="bi bi-download  px-1"></i>
                                                </button>
                                            </div>

                                            <div title="Eliminar Documento(Si se elimina no se podra recuperar)" [ngClass]="{'disabled-section': FacPro_VoBo === 'VoBo' && rol !== 'Administrador'}">
                                                <button class="btn btn-outline-danger btn-delete" type="button" id="basic-addon1" (click)="deleteDocumentS3(document)">
                                                    <i class="bi bi-trash px-1"></i>
                                                </button>
                                            </div>

                                        </div>
                                    </div>

                                </div>

                                <h5 class="card-title mt-5 text-center">Agregar Facturas </h5>
                                <p class="text-secondary text-center">(Solo Admite Archivos PDF)</p>

                                <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)" (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)" [ngClass]="{'disabled-section': FacPro_VoBo === 'VoBo' && rol !== 'Administrador'}">
                                    <ng-template (click)="openFileSelector()" ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                                        <p (click)="openFileSelector()">Arrastra y suelta tus archivos aquí o haz clic para seleccionar archivos.</p>
                                        <input type="file" id="fileInput" style="display: none">
                                    </ng-template>
                                </ngx-file-drop>
                            </div>

                        </div>
                        <!-- SPACER -->
                        <div class="col-md-6 m-0 p-0"></div>
                        
                        <br>

                    </div>

                    <!-- Tabla de Documentos al Agregar -->
                    <div class="row g-3">
                        <h5 class="card-title" *ngIf="newdocuments.length > 1">Documentos nuevos</h5>
                        <div class="col-md-4" *ngFor="let document of newdocuments; let i=index">
                            <div class="input-group mb-3">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="bi bi-file-earmark-pdf-fill text-danger"></i>
                                </span>
                                <input type="text" class="form-control" placeholder="{{document.name}}" disabled aria-label="Username" aria-describedby="basic-addon1">

                                <div title="Eliminar Documento">
                                    <button class="btn btn-outline-danger btn-delete" type="button" id="basic-addon1" (click)="quitDocument(i)">
                                        <i class="bi bi-trash px-1"></i>
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>

                    <!-- SPACER -->
                    <div class="col-md-6 m-0 p-0">
                    </div>

                    <!-- END ATTACH FILE ARRANGE -->

                </div>
            </form>
        </div>
    </div>

    <!-- FORM FOOTER -->
    <div class="container">
        <div class="card card-body INN-form justify-content-center mt-2 mb-4">
            <div class="row">

                <!-- FORM FOOTER CONTENT -->
                <!-- FUNCTIONS BUTTONS -->
                <div class="col ms-2 m-lg-0 d-lg-flex justify-content-lg-end align-items-lg-end">
                            
                    <div *ngIf="opE === '1' && mostrarBtnReFactura === false" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="editar()" class="INN-function-button link-opacity-50-hover text-decoration-none link-secondary fs-6">
                            <i class="bi-pencil-square me-2"></i>Editar
                        </button>
                    </div>

                    <div *ngIf="opE === '1' " class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button class="INN-function-button link-opacity-50-hover text-decoration-none link-secondary f-6" data-bs-toggle="collapse" href="#multiCollapseExample1" role="button" aria-expanded="false" aria-controls="multiCollapseExample1">
                            <i class="bi bi-chat-left-text me-2"></i>Comentario
                        </button>
                    </div>

                    <div *ngIf="opE === '1' && mostrarBtnReFactura === false && this.FacPro_VoBo !== 'VoBo' " class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="cambioEstatus()" class="INN-function-button link-opacity-50-hover text-decoration-none link-success fs-6">
                            <i class="bi bi-person-check-fill me-2 "></i>VoBo
                        </button>
                    </div>

                    <div *ngIf="opE === '1' && mostrarBtnReFactura === false" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="eliminar()" class="INN-function-button link-opacity-50-hover text-decoration-none link-danger fs-6">
                            <i class="bi-trash3 me-2"></i>Eliminar
                        </button>
                    </div>

                    <div *ngIf="opE === '2' " class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="guardar()" class="INN-function-button link-opacity-50-hover text-decoration-none link-secondary fs-6">
                            <i class="bi-save me-2"></i>Guardar
                        </button>
                    </div>

                    <div class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="cancelar()" class="INN-function-button link-opacity-50-hover text-decoration-none link-secondary fs-6">
                            <i [ngClass]="[iconoMostrar, 'me-2']"></i> {{nameBoton}}
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- FIXED SPACE FOR MAIN FOOTER-->
    <div class="container">
        <div class="row mb-4 pb-4">
        </div>
    </div>

</div>
<!-- END MAIN CONTAINER -->
